import React, { Component, Fragment } from 'react';
import { Datagrid, List, Loading, TextField } from 'react-admin';
import { Route } from 'react-router';
import { Drawer, withStyles } from '@material-ui/core';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import FacilityFilter from './FacilityFilter';
import ImageSourceField from './../ImageSourceField';
import PhotoCounterField from './../PhotoCounterField';
import FacilityEdit from './FacilityEdit';

const drawerStyles = {
  drawerContent: {
    width: 500,
  },
};

const FacilityListActions = () => <div></div>;

class FacilityListComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { loadingRecords: false };
  }

  handleClose = () => {
    this.props.push('/facilities');
  };

  loadingRecords = () => {
    this.setState({
      loadingRecords: true,
    });
  };

  componentDidUpdate(prevProps) {
    if (
      !prevProps.isLoading &&
      this.props.isLoading &&
      this.state.loadingRecords
    ) {
      this.setState({
        loadingRecords: false,
      });
    }
  }

  render() {
    const { push, classes, ...props } = this.props;

    return (
      <Fragment>
        <List
          {...props}
          title="Facilities"
          actions={<FacilityListActions />}
          bulkActionButtons={false}
          filters={<FacilityFilter loadingRecords={this.loadingRecords} />}
        >
          {this.state.loadingRecords ? (
            <Loading />
          ) : (
            <Datagrid rowClick="edit">
              <ImageSourceField />
              <TextField source="name" label="Name" />
              <TextField source="city" label="City" />
              <TextField source="state" label="State" />
              <TextField source="web_page" label="Web Page" />
              <TextField source="mobile_phone" label="Phone Number" />
              <PhotoCounterField source="photoCounter" label="Photo" />
            </Datagrid>
          )}
        </List>
        <Route path="/facilities/:id">
          {({ match }) => {
            if (!match) {
              return <div />;
            }
            const isMatch =
              match && match.params && match.params.id !== 'create';

            return (
              <Drawer open={isMatch} anchor="right" onClose={this.handleClose}>
                {/* To avoid any errors if the route does not match, we don't render at all the component in this case */}
                {isMatch ? (
                  <FacilityEdit
                    className={classes.drawerContent}
                    id={decodeURIComponent(match.params.id)}
                    onCancel={this.handleClose}
                    {...props}
                  />
                ) : (
                  <div className={classes.drawerContent} />
                )}
              </Drawer>
            );
          }}
        </Route>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.admin.loading > 0,
});

export default compose(
  connect(
    mapStateToProps,
    { push },
  ),
  withStyles(drawerStyles),
)(FacilityListComponent);
